export const SELECTORS = {
    container: '.appointment-confirmed__container',
    body: '.appointment-confirmed__body',
    card: '.appointment-confirmed__body .card',
    icon: '.appointment-confirmed__body .icon',
    checkIconWrapper: '.icon .custom-check-icon-wrapper',
    informationCard: '.appointment-confirmed__body .information .card',
    staffInfo: '.time-staff__info .staff__info',
    timeInfo: '.time-staff__info .time__info',
    dateInfo: '.date__info',
    actionDiv: '.card .action',
    appointmentButtons: '.appointment-confirm-single',
    title: '.appointment-confirmed__body .title',
    confirmBtn: '#confirm-appointment-btn',
    cancelLink: '#cancel-appointment-link',
    logo: '.appointment__logo',
    pendingBanner: '.pending-approval-banner',
    cancelledBanner: '.cancelled-appointment-banner'
};

export const MESSAGES = {
    errors: {
        eventIdNotFound: "Error: Event ID not found",
        locationUndefined: "Error! Location is undefined.",
        confirmFailed: "Error confirming appointment. Please try again.",
        cancelFailed: "Error cancelling appointment. Please try again.",
        copyFailed: "Error! Cannot copy to clipboard.",
        eventRoomUrlUnavailable: "Event room URL is not available",
        invalidResponse: "Invalid response from server"
    },
    success: {
        addressCopied: "Address copied to clipboard",
        confirmAppointment: "Appointment confirmed!",
        cancelAppointment: "Appointment cancelled!"
    },
    confirmations: {
        cancelAppointment: "Are you sure you want to cancel this appointment?"
    },
    ui: {
        processing: "Processing...",
        confirm: "Confirm",
        cancel: "Cancel",
        cancelled: "Cancelled",
        appointmentCancelled: "Your appointment has been cancelled",
        confirmAppointment: "Confirm Appointment"
    },
    banner: {
        pendingApproval: "Appointment confirmed! Waiting for staff approval.",
        pendingApprovalDescription: "We'll notify you once your appointment is approved by our team.",
        cancelled: "Appointment cancelled",
        cancelledDescription: "Your appointment has been successfully cancelled. You can book a new appointment anytime."
    }
};

export const BUTTON_CONFIG = {
    confirm: {
        id: 'confirm-appointment-btn',
        className: 'button--no-style confirm-button confirm-button-large',
        text: 'Confirm Appointment',
        loadingText: 'Processing...',
        type: 'button'
    },
    cancel: {
        id: 'cancel-appointment-link',
        className: 'cancel-link',
        text: 'Cancel Appointment',
        loadingText: 'Processing...',
        type: 'link'
    }
};

export const APPOINTMENT_STATUS = {
    REQUEST: 'request',
    CONFIRMED: 'confirmed',
    COMPLETE: 'complete',
    CANCELLED: 'cancelled'
};

export const PARTICIPANT_TYPES = {
    LEAD: 'App\\Models\\Lead',
    STAFF: 'App\\Models\\Staff'
};

export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    SERVER_ERROR: 500
};

export const COLORS = {
    error: '#e74c3c',
    success: '#11b654'
};

export const TIMEOUTS = {
    defaultToast: 3000,
    buttonReset: 2000
}; 